import styled from 'styled-components';
import tw from 'twin.macro';
import { useQuery } from '@apollo/client';
import { MY_ALLOWED_TO_DRIVE_TRIPS } from '../../../services/bookingService/queries';
import { AllowedToDriveTripsContent } from '../../../components/AllowedToDriveTripsContent';

const PageContainer = styled.div`
  ${tw`w-full max-w-full min-w-0 box-border min-h-screen bg-bg-secondary pb-16`}
`;

const Inner = styled.div`
  ${tw`w-full max-w-md mx-auto px-4 pt-6 md:pt-10`}
`;

const Title = styled.h1`
  ${tw`text-xl md:text-2xl font-bold text-text-primary mb-2`}
`;

const Subtitle = styled.p`
  ${tw`text-sm text-text-secondary mb-6 w-full max-w-full min-w-0 box-border`}
`;

export default function TripsAsAdditionalDriverPage() {
  const { data, loading } = useQuery(MY_ALLOWED_TO_DRIVE_TRIPS, {
    fetchPolicy: 'network-only',
  });

  const trips = data?.myAllowedToDriveTrips ?? [];

  return (
    <PageContainer>
      <Inner>
        <Title>Allowed to drive</Title>
        <Subtitle>Trips where you are listed as an additional driver</Subtitle>
        <AllowedToDriveTripsContent trips={trips} loading={loading} />
      </Inner>
    </PageContainer>
  );
}
